import React from 'react';
import {
  TitleField,
  TextField,
  PhoneNumberField,
  TextAreaField,
  // CardUploadFiled,
  CardUploadField,
} from 'components/Molecules/FormFields';
import { Row, Col } from 'antd';
import Alert from 'components/Molecules/Alert/index';
import { ReactComponent as LightingIcon } from 'assets/icons/Light.svg';
import T from 'i18n-react';
import classes from './Doc.module.scss';

const DOCGeneralInformation = () => {
  return (
    <>
      <TitleField level={5}>Company Information</TitleField>
      <TextField
        placeholder={T.translate('placeholder.fillHere')}
        name="general.companyName"
        label="Name"
        required
      />
      <TextField
        placeholder={T.translate('placeholder.fillHere')}
        name="general.companyAddress"
        label="Address"
        required
      />
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <PhoneNumberField name="general.companyPhone" label="Phone Number" required />
        </Col>
        <Col span={12}>
          <TextField name="general.companyContactEmail" label="Email Address" required />
        </Col>
      </Row>
      <CardUploadField
        layoutClasses={classes.cardUploadField}
        name="general.companyLogo"
        title={
          <span>
            Company Logo <sub style={{ color: 'red', bottom: 0, fontSize: 14 }}>*</sub>
          </span>
        }
        shouldShowUpload={(fileList) => {
          if (fileList && !!fileList.length) {
            return false;
          }
          return true;
        }}
        uploadPlacement="bottom"
        uploadBtnText="Add New Logo"
        renderTopContent={() => {
          return (
            <Alert
              className={classes.alert}
              visible
              type="info"
              closable={false}
              message={
                <span>
                  The photo is originally from QMAS{' '}
                  <a target="_blank" href="/company-profile">
                    Company Profile
                  </a>
                  . You can go to Company Profile to adjust if necessary or you can add a new one
                  here.
                </span>
              }
              showIcon
              icon={
                <span>
                  <LightingIcon />
                </span>
              }
            />
          );
        }}
      />
      <TitleField level={5}>Product Information</TitleField>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <TextField
            placeholder={T.translate('placeholder.fillHere')}
            name="general.productName"
            label="Product Name"
            required
          />
        </Col>
        <Col span={12}>
          <TextField
            placeholder={T.translate('placeholder.fillHere')}
            name="general.productModel"
            label="Product / Model / Batch Number"
            required
          />
        </Col>
      </Row>
      <CardUploadField
        layoutClasses={classes.cardUploadField}
        name="general.productPictures"
        title={
          <span>
            Product Pictures <sub style={{ color: 'red', bottom: 0, fontSize: 14 }}>*</sub>
          </span>
        }
        uploadBtnText="Add Photo"
      />
      <TitleField level={5}>Additional Information</TitleField>
      <TextAreaField name="general.remark" label="Remark" />
    </>
  );
};

export default DOCGeneralInformation;
